export enum FIELD_NAMES {
  currentPassword = 'currentPassword',
  newPassword = 'newPassword',
}
